// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rr-2";
export var messageContent = "_rr-0";
export var messagesScroll = "_rr-1";
export var shimmer = "_rr-3";
export var shimmerW100 = "_rr-4";
export var shimmerW70 = "_rr-8";
export var shimmerW80 = "_rr-7";
export var shimmerW85 = "_rr-6";
export var shimmerW90 = "_rr-5";